import { ChangeDetectorRef, Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { Router } from '@angular/router';
import { Center } from '../../models/center';
import { CenterService } from '../../services/center.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LogService } from '../../services/log.service';
import _ from 'lodash';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { ApiError } from '../../models/apiError';
import { TooltipModule } from 'primeng/tooltip';
import { SearchFieldComponent } from '../../components/search-field/search-field.component';
import { AuxiliarService } from '../../services/auxiliar.service';

@Component({
  selector: 'app-centers',
  imports: [
    ButtonModule,
    CardModule,
    ConfirmPopupModule,
    DialogModule,
    SearchFieldComponent,
    TableModule,
    TooltipModule,
    TranslatePipe,
  ],
  providers: [
    ConfirmationService,
  ],
  templateUrl: './centers.component.html',
  styleUrl: './centers.component.scss',
})
export class CentersComponent implements OnInit {
  public centers = computed(() => {
    const filter = this.auxiliarService.searchField();
    return _.filter(this.centersRaw(), (c: Center) => {
      return _.some(['name', 'town', 'province'], (field: string) => {
        return _.includes(_.toLower(_.deburr(_.get(c, field))), filter);
      });
    });
  });
  private centersRaw = signal<Center[]>([]);
  private readonly destroy$ = inject(DestroyRef);
  public loadingCenters = true;

  constructor(
    private auxiliarService: AuxiliarService,
    private cdr: ChangeDetectorRef,
    private centerService: CenterService,
    private confirmationService: ConfirmationService,
    private logService: LogService,
    private router: Router,
    private translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.getCenters();
  }

  private getCenters(): void {
    this.loadingCenters = true;
    this.centerService.getCenters().pipe(takeUntilDestroyed(this.destroy$)).subscribe({
      next: (res) => {
        this.logService.info('[Center] - getCenters', _.get(res, 'body'));
        this.centersRaw.set(_.get(res, 'body.data', []));
        this.loadingCenters = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.logService.error('[Center] - getCenters', err, this.translate.instant('error.centers'));
      }
    });
  }

  public addCenter(): void {
    this.router.navigate(['admin', 'centers', 'center-detail']);
  }

  public gotoDetail(id: number): void {
    this.router.navigate(['admin', 'centers', 'center-detail', id]);
  }

  public deleteCenter(event: Event, center: Center): void {
    this.confirmationService.confirm({
      target: event.currentTarget as EventTarget,
      message: this.translate.instant('confirmation.center-delete'),
      icon: 'pi pi-info-circle',
      acceptLabel: this.translate.instant('yes'),
      rejectLabel: this.translate.instant('no'),
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      accept: () => {
        this.centerService.deleteCenter(center.id!).pipe(takeUntilDestroyed(this.destroy$)).subscribe({
          next: (res) => {
            this.logService.info('Center', res, this.translate.instant('success.center-delete'));
            this.getCenters();
          },
          error: (err: ApiError) => {
            this.logService.error('[Center] - deleteCenter', err, this.translate.instant('error.center-delete'));
          }
        });
      },
      reject: () => {}
    });
  }
}
